import type { FiscalYearPreview } from 'utils/fiscalPeriods';

import { QUARTER_COUNT } from './shared';

interface Props {
  readonly year: FiscalYearPreview;
  readonly patternLabel: string;
}

/** Proportional strip visualising the twelve periods of one fiscal year. */
export const PeriodStrip = ({ year, patternLabel }: Props) => (
  <>
    <div className="mb-2 small text-muted">
      FY {year.year} periods — {patternLabel}
      {year.weeks === 53 ? ', last period +1 week' : ''}
    </div>
    <div className="fiscal-period-editor__strip mb-3" aria-hidden="true">
      {year.periods.map((period) => (
        <div
          key={period.period}
          className={`fiscal-period-editor__strip-period fiscal-period-editor__strip-period--q${period.quarter}`}
          style={{ flex: period.weeks }}
          title={`P${period.period} · Q${period.quarter} · ${period.weeks} weeks · ${period.start} → ${period.end}`}
        >
          P{period.period}
        </div>
      ))}
    </div>
    <div className="d-flex gap-3 small text-muted mb-3">
      {Array.from({ length: QUARTER_COUNT }, (_, index) => (
        <span key={index}>
          <span className={`d-inline-block rounded-circle me-1 fiscal-period-editor__quarter-dot fiscal-period-editor__quarter-dot--q${index + 1}`} />Q
          {index + 1}
        </span>
      ))}
    </div>
  </>
);
